<app-fixed-editor *ngIf="element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>
<div class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container">
    <div class="new-question--titleBox"
      [class.score-applied]="isSubmitted && element?.isScoring && _answer && points  && isResultPublished">
      <p class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24" [innerHTML]="element?.question"></p>
      <!-- <span *ngIf="!isPractice && isSubmitted && element?.isScoring && _answer && points  && isResultPublished && !isTouchstone"
        class="answer-point">Points:
        {{(points?points.point:0 ) | number:'1.0-2'}} out of
        {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
      <div *ngIf="element?.description && !isSubmitted" class="new-question--hint">{{ element?.description}}</div>
    </div>
    <div class="new-options new-options__twothird-width">
      <div [class.next-button-spacing]="!isSubmitted">
        <div class="mg-b40" *ngIf="element?.type === 'DOC'">
          <app-doc-response [isSubmitted]="isSubmitted" [url]="_answer" (responseUrl)="urlHandller($event)"></app-doc-response>
        </div>
        <div class="pd-t30">
          <app-video-response (recordingStarted)="recordingHandler($event)" [recorderId]="element?._id" [stopCameraTag]="stopCameraTag" [isSubmitted]="isSubmitted" [url]="_answer" (responseUrl)="urlHandller($event)" *ngIf="element?.type === 'VIDEO'" [questionUrl]="questionUrl" [playerindex]="playerindex"></app-video-response>
        </div>
        <div class="mg-b40" *ngIf="element?.type === 'AUDIO'">
          <app-audio-response (recordingStarted)="recordingHandler($event)" [recorderId]="element?._id" [stopCameraTag]="stopCameraTag" [isSubmitted]="isSubmitted" [url]="_answer" (responseUrl)="urlHandller($event)"></app-audio-response>
        </div>
        <!-- <p class="pt-4 font-16 lh-30"
          *ngIf="!isSubmitted && questionChecked && immediateFeedBackRequired && !disableNavButton">Your response has
          been submitted and will be evaluated by a Harappa Learning Specialist. We will notify you when the feedback is
          available!
        </p> -->
        <div *ngIf="!isSubmitted && questionChecked && immediateFeedBackRequired && !disableNavButton && element?.isFeedbackEnabled" class="overall-feedback pb-4">
          <p class="overall-feedback__desc" [froalaView]="element.feedback"></p>
        </div>
        <div *ngIf="isSubmitted && element?.isFeedbackEnabled" class="overall-feedback pb-4">
          <p class="overall-feedback__desc" [froalaView]="element.feedback"></p>
        </div>
        <ng-container *ngIf="!disableNavButton">
          <app-exercise-navigation-bar *ngIf="!isSubmitted" [id]="id" [immediateFeedBackRequired]="immediateFeedBackRequired"
            [questionAttempted]="questionAttempted" (onReview)="check()" (onNext)="next()" (onSubmit)="next(true)"
            [questionChecked]="questionChecked"
            [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
            [index]='index'
    >
          </app-exercise-navigation-bar>
        </ng-container>
      </div>
      <ng-container *ngIf="isSubmitted">
        <p class="pt-4 font-16 lh-30" *ngIf="_answer && !isResultPublished">Your response has
          been submitted and will be evaluated by a Harappa Learning Specialist. We will notify you when the feedback is
          available!
        </p>
        <div *ngIf="taFeedback?.feedback && !taFeedback?.rowsFeedback?.length>0" class="overall-feedback">
          <p [froalaView]="taFeedback.feedback" class="overall-feedback__desc"></p>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="isSubmitted">
    <!-- thrive -->
    <ng-container *ngIf="questionBlos && questionBlos.length">     
      <h5 class="question__thrive">Thrive Skills:</h5>
      <div class="question__thrive-list">
        <ul>
          <ng-container *ngFor="let blo of questionBlos">
            <li [innerHTML]="blo.shortStatement"></li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <div class="new-question__container">
      <app-rowsfeedback  [taFeedback]="taFeedback" *ngIf="taFeedback?.rowsFeedback?.length>0"></app-rowsfeedback>
    </div>
  </ng-container>
</div>
